<template>
  <FormContainer withoutDivider>
    <template #title>Informations apprenti(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_26"
          v-model="nomNaissanceModel"
          label="Nom de naissance"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :required="meta.apprenti?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.nomNaissance?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
          help="Le nom de naissance doit correspondre à l'identité officielle de l'apprenti(e) (attention aux inversions si nom de naissance composé)"
        />
        <WrapperInput
          id="field_27"
          v-model="nomUsageModel"
          label="Nom d'usage (si différent)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :required="meta.apprenti?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.nom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_28"
          v-model="prenomModel"
          label="Prénom (le premier selon l'état civil)"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :required="meta.apprenti?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.prenom?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_29"
          v-model="nirTemporaireModel"
          label="Êtes-vous détenteur d'un NIR temporaire ?"
          :required="meta.apprenti?.nirTemporaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.nirTemporaire?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
          help="Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale"
        />
        <WrapperInput
          id="field_30"
          v-model="nirModel"
          :label="nirLabel"
          :hint="nirHint"
          class="col-10 col-md-12 col-sm-36"
          placeholder="Ex : 1234567890123"
          :required="meta.apprenti?.nir?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.nir?.$messageErreurDirty!"
          :maxlength="nirMaxLength"
          deletable
          :readonly
          :help="nirHelp"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_31"
          v-model="dateNaissanceModel"
          label="Date de naissance"
          :hint="HINT_DATE"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :required="meta.apprenti?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.dateNaissance?.$messageErreurDirty!"
          :readonly
        />
        <WrapperDropdown
          id="field_32"
          key="sexe-dropdown"
          v-model="sexeModel"
          label="Sexe"
          class="col-4 col-md-12 col-sm-36"
          :items="sexeItems"
          :readonly
          :required="meta.apprenti?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.sexe?.$messageErreurDirty!"
        />
        <WrapperInput
          id="field_33"
          v-model="departementNaissanceModel"
          label="Département de naissance"
          hint="3 caractères maximum"
          class="col-6 col-md-12 col-sm-36"
          placeholder="Ex : 75"
          :maxlength="3"
          deletable
          :required="meta.apprenti?.departementNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.departementNaissance?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInput
          id="field_34"
          v-model="communeNaissanceModel"
          label="Commune de naissance"
          class="col-8 col-md-12 col-sm-36"
          placeholder="Ex: Paris"
          :maxlength="50"
          deletable
          :required="meta.apprenti?.communeNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.communeNaissance?.$messageErreurDirty!"
          :readonly
        />
        <WrapperDropdown
          id="field_35"
          key="nationalite-dropdown"
          v-model="nationaliteModel"
          label="Nationalité"
          class="col-10 col-md-18 col-sm-36"
          :items="nationaliteItems"
          :required="meta.apprenti?.nationalite?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.nationalite?.$messageErreurDirty!"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_36"
          v-model="regimeSocialModel"
          label="Régime social"
          class="col-8 col-md-12 col-sm-36"
          :items="regimeSocialItems"
          :required="meta.apprenti?.regimeSocial?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.regimeSocial?.$messageErreurDirty!"
          :readonly
        />
        <WrapperDropdown
          id="field_37"
          key="csp-dropdown"
          v-model="cspModel"
          label="Catégorie socio-professionnelle (CSP)"
          class="col-16 col-md-18 col-sm-36"
          :items="lov.Csp"
          :required="meta.apprenti?.csp?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.csp?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>

      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_38"
          v-model="sportifHautNiveauModel"
          label="Inscrit sur la liste des sportifs de haut niveau"
          :required="meta.apprenti?.inscritSurListeSportifs?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.inscritSurListeSportifs?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperToggleSwitch
          id="field_45"
          v-model="projetCreationEntrepriseModel"
          label="Projet de création ou de reprise d'entreprise"
          :required="meta.apprenti?.projetCreationOuReprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.projetCreationOuReprise?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_39"
          v-model="handicapeModel"
          label="Qualité de travailleur handicapé"
          :items="OuiOuNon"
          :required="meta.apprenti?.beneficieReconnaissanceTravailleurHandicape?.$status === PropertyStatus.Required"
          :alertLabel="meta.apprenti?.beneficieReconnaissanceTravailleurHandicape?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <BasicText class="col-36">
          <strong style="text-decoration: underline;">Si non</strong>, bénéficiez-vous de droits attachés à la RQTH:
        </BasicText>
        <div class="col-10 col-md-14 col-sm-36 flex">
          <WrapperToggleSwitch
            v-if="meta.apprenti?.equivalenceJeune?.$status !== PropertyStatus.NotPresent"
            v-model="equivalenceJeuneModel"
            label="Équivalence jeunes"
            :items="OuiOuNon"
            :required="meta.apprenti?.equivalenceJeune?.$status === PropertyStatus.Required"
            :alertLabel="meta.apprenti?.equivalenceJeune?.$messageErreurDirty!"
            :readonly
            class="flex-1"
          />
          <WrapperToggleSwitch
            v-else
            label="Équivalence jeunes"
            :items="OuiOuNon"
            disabled
            class="flex-1"
          />
          <BasicButton
            class="flex-none align-self-flex-end help-btn"
            type="primary"
            _iconName="help"
            variant="filled"
            label="?"
            @click="helpEquivalenceJeune = true">
          </BasicButton>
          <teleport to="#app">
            <modal-component closable v-model="helpEquivalenceJeune">
              <template #header>
                <BasicText size="h4">Equivalence jeunes</BasicText>
              </template>
              <template #content>
                <div class="flex flex-column flex-gap-4" style="max-width: 600px">
                  <p>
                    <BasicText>
                      A compter du 1er janvier 2024, pour les personnes âgées de 15 ans révolus à 20 ans, les titres suivants valent RQTH et ouvrent aux aménagements du contrat d’apprentissage (cf. article L. 5213-2 du code du travail).
                    </BasicText>
                  </p>
                  <ul>
                    <li>
                      <BasicText size="body-l">Notification de la Prestation de Compensation du Handicap (PCH)</BasicText>
                    </li>
                    <li>
                      <BasicText size="body-l">Notification de l’Allocation d’Education de l’Enfant Handicapé (AEEH)</BasicText>
                    </li>
                    <li>
                      <BasicText size="body-l">Le bénéfice d’un projet Personnalisé de Scolarisation (PPS)</BasicText>
                    </li>
                  </ul>
                  <p>
                    <BasicText>
                      Si vous bénéficiez de l’un de ces titres, indiquez « OUI » au champ « Equivalence jeunes » du cerfa.
                    </BasicText>
                  </p>
                </div>
              </template>
            </modal-component>
          </teleport>
        </div>
        <div class="col-10 col-md-14 col-sm-36 flex">
          <WrapperToggleSwitch
            v-if="meta.apprenti?.extensionBOE?.$status !== PropertyStatus.NotPresent"
            v-model="extensionBOEModel"
            label="Extension BOE"
            :items="OuiOuNon"
            :required="meta.apprenti?.extensionBOE?.$status === PropertyStatus.Required"
            :alertLabel="meta.apprenti?.extensionBOE?.$messageErreurDirty!"
            :readonly
            class="col-10 col-md-14 col-sm-36"
          />
          <WrapperToggleSwitch
            v-else
            label="Extension BOE"
            :items="OuiOuNon"
            disabled
            class="col-10 col-md-14 col-sm-36"
          />
          <BasicButton
            class="flex-none align-self-flex-end help-btn"
            type="primary"
            _iconName="help"
            variant="filled"
            label="?"
            @click="helpExtensionBOEModel = true">
          </BasicButton>
          <teleport to="#app">
            <modal-component closable v-model="helpExtensionBOEModel">
              <template #header>
                <BasicText size="h4">Extension BOE</BasicText>
              </template>
              <template #content>
                <div class="flex flex-column flex-gap-4" style="max-width: 600px">
                  <p>
                    <BasicText>
                      A compter du 1er janvier 2024, les droits liés à la RQTH sont étendus aux personnes bénéficiaires de l'obligation d'emploi (BOE) hors ayants-droits (cf. article L. 5212-13-1 du code du travail) : il convient de cocher OUI au champ « Extension BOE » du cerfa pour bénéficier des aménagements prévus pour les apprentis en situation de handicap.                    </BasicText>
                  </p>
                </div>
              </template>
            </modal-component>
          </teleport>
        </div>
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_DATE_NAIS,
    PLACEHOLDER_NOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_PRENOM,
  } from '@/features/interface/demande/shared'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { nationaliteItems, sexeItems, OuiOuNon } from '@/features/interface/shared/tools'
  import { regimeSocialItems } from '@/features/interface/demande/capp/dropdown-items'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { model, meta, lov, readonly } = storeToRefs(store)


  const nomNaissanceModel = setupFieldWithKey<string>('apprenti.nomNaissance', true)
  const nomUsageModel = setupFieldWithKey<string>('apprenti.nom', true)
  const prenomModel = setupFieldWithKey<string>('apprenti.prenom', true)
  const nirTemporaireModel = setupFieldWithKey<boolean>('apprenti.nirTemporaire', false)
  const nirModel = setupFieldWithKey<string>('apprenti.nir', true)
  const nirMaxLength = computed(() => {
    return model.value?.apprenti?.nirTemporaire === true ? 40 : 13
  })

  const nirHint = computed(() => {
    return model.value?.apprenti?.nirTemporaire === true ? '11 à 40 caractères' : '13 caractères'
  })

  const nirHelp = computed(() => {
    return model.value?.apprenti?.nirTemporaire === true
      ? "Le numéro technique temporaire est un numéro attribué à l'individu par son employeur dans l'attente de la délivrance d'un NIA puis d'un NIR définitif par la sécurité sociale."
      : 'Le numéro de sécurité sociale est inscrit sur la carte vitale, en dessous du nom et du prénom du porteur.'
  })

  const nirLabel = computed(() => {
    return model.value?.apprenti?.nirTemporaire === true
      ? 'Numéro technique temporaire'
      : 'Numéro de sécurité sociale (NIR)'
  })

  const dateNaissanceModel = setupFieldWithKey<string>('apprenti.dateNaissance', true)
  const departementNaissanceModel = setupFieldWithKey<string>('apprenti.departementNaissance', true)
  const communeNaissanceModel = setupFieldWithKey<string>('apprenti.communeNaissance', true)
  const regimeSocialModel = setupFieldWithKey<string>('apprenti.regimeSocial', true)
  const sportifHautNiveauModel = setupFieldWithKey<boolean>('apprenti.inscritSurListeSportifs')
  const cspModel = setupFieldWithKey<string>('apprenti.csp')
  const nationaliteModel = setupFieldWithKey<string>('apprenti.nationalite')
  const sexeModel = setupFieldWithKey<string>('apprenti.sexe')
  const projetCreationEntrepriseModel = setupFieldWithKey<boolean>('apprenti.projetCreationOuReprise')
  const handicapeModel = setupFieldWithKey<boolean>('apprenti.beneficieReconnaissanceTravailleurHandicape')
  const equivalenceJeuneModel = setupFieldWithKey<boolean>('apprenti.equivalenceJeune')
  const extensionBOEModel = setupFieldWithKey<boolean>('apprenti.extensionBOE')
  const helpEquivalenceJeune = ref(false)
  const helpExtensionBOEModel = ref(false)

</script>
